import { DataSourceExecutionEvent, Label, TableRow, TableRowDisplayEvent, Image } from "@mcleod/components";
import { AutogenLayoutLinkedMovesQuickInfoTable } from "./autogen/AutogenLayoutLinkedMovesQuickInfoTable";
import { ModelRow, Navigation } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { YSplit } from "../YSplit";

export class LinkedMovesQuickInfoTable extends AutogenLayoutLinkedMovesQuickInfoTable {

    sourceMovementStopsAfterExecution(event: DataSourceExecutionEvent) {
        this.labelId.text = this.mainDataSource.lastSearch.data.linked_id;
        this.tableLinkedMoves.selectedRow = this.tableLinkedMoves.rows.find(row => row.data.get("id") === this.mainDataSource.lastSearch.data.selected_movement_id);
    }

    tableLinkedMovesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const modelRow: ModelRow = tableRow.data;
        const labelOrderId = tableRow.findComponentById("labelOrderId") as Label;
        const labelManifestId = tableRow.findComponentById("labelManifestId") as Label;
        const zmitImage = tableRow.findComponentById("imageZmit") as Image;

        const xmitted2driver = !modelRow.isNull("xmitted2driver");
        const xmitAccepted = modelRow.get("xmit_accepted");
        this.displayZmitImage(zmitImage, xmitted2driver, xmitAccepted);

        const status = tableRow.findComponentById("imageStatus") as Image;
        this.displayStatus(status, modelRow.get("status"));

        const hasManifest = !modelRow.isNull("manifest_id");
        if ((labelOrderId || labelManifestId) && (!modelRow.isNull("orders.id") || hasManifest)) {
            labelManifestId.visible = hasManifest;
            labelOrderId.visible = !hasManifest;
            const orderIdLink = `lme/dispatch/OrderTabView?mode\u003dupdate\u0026key\u003d${modelRow.get("orders.id")}`;
            const manifestIdLink = `lme/dispatch/OrderList?manifest_id=${modelRow.get("manifest_id")}`;
            const labelToUse = hasManifest ? labelManifestId : labelOrderId;
            labelToUse.link = hasManifest ? manifestIdLink : orderIdLink;
            labelToUse.handleLinkClick = () => Navigation.navigateTo(labelToUse.link, { newTab: true });
            labelToUse.tooltip = `Click to view ${hasManifest ? "manifest" : "order"}`;
            labelToUse.addUnderlineWhenMouseOver();
        }

        const isOnHold = modelRow.getBoolean("orders.on_hold", false);
        const imageHold = tableRow.findComponentById("imageHold") as Image;
        imageHold.visible = isOnHold;
        this.updateYsplitImage(tableRow);
    }

    private updateYsplitImage(tableRow: TableRow) {
        const modelRow = tableRow.data;
        const imageYsplit = tableRow.findComponentById("imageYsplit") as Image;
        YSplit.setImage(modelRow.get("origin_stop.stop_type"), modelRow.get("dest_stop.stop_type"), imageYsplit);
        imageYsplit.visible = imageYsplit.color != null;
    }

    private displayZmitImage(zmitImage: Image, xmitted2driver: boolean, xmitAccepted: string) {
        const imageProps = this.getZMitImageProps(!xmitted2driver, xmitAccepted);

        zmitImage.visible = imageProps.name !== null;
        zmitImage.name = imageProps.name;
        zmitImage.field = imageProps.field;
        zmitImage.displayLabel = imageProps.displayLabel;
        zmitImage.tooltip = imageProps.tooltip;
    }

    private getZMitImageProps(zMitNotTransmitted: boolean, zmitAccepted: string): { name: ImageName, field: string, displayLabel: string, tooltip: string } {
        if (zMitNotTransmitted) {
            return { name: null, field: "xmitted2driver", displayLabel: "Load Not Transmitted", tooltip: "Load Not Transmitted" }
        } else if (zmitAccepted == null) {
            return { name: ImageName.zMitTransmitted, field: "xmitted2driver", displayLabel: "Load Transmitted", tooltip: "Load Transmitted" }
        } else if (zmitAccepted === 'Y') {
            return { name: ImageName.zMitTransmittedAccepted, field: "xmit_accepted", displayLabel: "Load Accepted", tooltip: "Load Accepted" }
        } else if (zmitAccepted === 'N') {
            return { name: ImageName.zMitTransmittedRejected, field: "xmit_accepted", displayLabel: "Load Rejected", tooltip: "Load Rejected" }
        }

        return { name: null, field: "xmitted2driver", displayLabel: null, tooltip: null };
    }

    displayStatus(statusImage: Image, status: string) {
        let imageName: ImageName;
        let tooltip: string;
        switch (status) {
            case 'A':
                imageName = ImageName.loadAvailable;
                tooltip = "Available";
                break;
            case 'P':
                imageName = ImageName.loadInProgress;
                tooltip = "In Progress";
                break;
            case 'D':
                imageName = ImageName.loadDelivery;
                tooltip = "Delivered";
                break;
        }
        statusImage.name = imageName;
        statusImage.tooltip = tooltip;
    }

}
